import { combineReducers } from "redux"
import user from "./user"
import file from "./file"
import item from "./item"

export default combineReducers({ user, file, item })
